export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const PROJECT_SETCURRENT = 'PROJECT_SETCURRENT'
export const PROJECT_UPDATELIST = 'PROJECT_UPDATELIST'

export const LSIDEBAR_CHANGE = 'LSIDEBAR_CHANGE'
